export const TOGGLE_LOOPING = 'settings/toggleLooping';
export const TOGGLE_MUTE = 'settings/toggleMute';
